// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__KMM32","paramInput":"JobSimulator_paramInput__3jd2Y","input":"JobSimulator_input__BAdKJ"};